import React from 'react';
import amazonLogo from '../amazon_logo.svg';
import { ERR_CODE } from '../utils/constants';
import { t, withBundle } from '../translationHelper';

class ErrorPage extends React.Component<any, any> {
    state = {
        code: ""
    };

    componentDidMount() {
        const params = new URLSearchParams(window.location.search);
        const errorCode = params.get(ERR_CODE);
        this.setState({
            code: this.props.code ?? errorCode ?? ""
        });
    }

    getErrorMessage() {
        switch (this.state.code) {
            case "404":
                return t(this.props.bundle, 'errorCauseNotFound');
            case "403":
                return t(this.props.bundle, 'errorCauseUnauthorized');
            default:
                return "";
        }
    }

    render() {
        const { bundle } = this.props;
        return (
            <div>
                <img className="amazon-logo" src={amazonLogo} alt="Amazon Logo" />
                <h4>{t(bundle, 'errorPageHeading')}</h4>
                { this.state.code &&
                    <h5>
                        <p>{t(bundle, 'errorPageCause', { cause: this.getErrorMessage() })}</p>
                    </h5>
                }
            </div>
        )
    };
}

export default withBundle(ErrorPage);
